export const TRAVELERS_TEXT = "Travelers";
